import { useState } from "react";
import { Form } from "react-bootstrap";
import { SubTask } from "../../interfaces/Task";
import CustomEditor from "../../elements/CustomEditor";
import { useTranslation } from "react-i18next";

export interface SubTaskTeacherNotesEditProps {
    task_id: string;
    subTask: SubTask;
    save: CallableFunction;
}

export default function SubTaskTeacherNotesEdit(props: SubTaskTeacherNotesEditProps) {
    const { t } = useTranslation();
    
    const [teacher_notes, setTeacherNotes] = useState(props.subTask.teacher_notes);
    
    const save = (event: any) => {
        event.preventDefault();
        props.save(teacher_notes);
    }

    const handleTeacherNotesChange = (data: string) => {
        setTeacherNotes(data);
    }
    
    const doNothing = (text: string) => {

    }

    return(
        <div className="edit-sub-task-prompt-container">
            <div className="inner">
                <Form className="sub-task-edit-form" onSubmit={ save }>
                    <div className="field field-teachernotes">
                        <CustomEditor
                            change={ handleTeacherNotesChange }
                            changeFormatted={ doNothing }
                            data={ teacher_notes }
                            formatted={ '' }
                            id="teachernotes"
                            label=''
                            npl={ false }
                            task_id={ props.task_id }
                        />
                    </div>
                    <div className="actions">
                        <button className="btn btn-primary" type="submit">
                            { t("Save") }
                        </button>
                    </div>
                </Form>
            </div>
        </div>
    );
}